export const CLASS_CARD_CUSTOM = 'card-details-custom';
